import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/logs`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const logsApi = {
  postLogs: (request) => {
    const { error } = request
    const { stack, message, name } = error
    const body = {
      name,
      message,
      stack: JSON.stringify(stack)
    }
    return instance().post('/', body)
  }
}
export default logsApi



// WEBPACK FOOTER //
// ./src/api/logs.js